import { Button, Popconfirm, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface FAListComponentProps {
  data: any[];
  isMyAsset: boolean;
  openEditModal: (data: any) => void;
  deleteFA: (id: number) => void;
}

function FAListComponent({
  data,
  isMyAsset,
  openEditModal,
  deleteFA,
}: FAListComponentProps) {
  const columns: ColumnsType<any> = [
    {
      title: '이름',
      dataIndex: 'name',
      width: '30%',
      render: (text: any, record: any) => <>{text.replaceAll('+', ' ')}</>,
    },
    {
      title: '번호',
      dataIndex: 'number',
      width: '20%',
    },
    {
      title: '종류',
      dataIndex: 'clientType',
      width: '10%',
      render: (text: any, record: any) => <>{text === '0' ? '개인' : '법인'}</>,
    },
    {
      title: '경비환급',
      dataIndex: 'isRefund',
      width: '15%',
      render: (text: any, record: any) => (
        <>{record.isRefund === true ? '예' : '아니오'}</>
      ),
    },
    {
      title: '담당자',
      dataIndex: ['user', 'name'],
      width: '15%',
      render: (text: any, record: any) => <>{text}</>,
    },
    {
      title: '카드연동',
      dataIndex: 'isConnected',
      width: '15%',
      render: (text: any, record: any) => (
        <>{record.isConnected === true ? '예' : '아니오'}</>
      ),
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      width: '15%',
      render: (text, record, index) =>
        !isMyAsset && (
          <Space size="small">
            <Button size="small" onClick={() => openEditModal(record)}>
              수정
            </Button>
            <div onClick={(e) => e.stopPropagation()}>
              <Popconfirm
                title="정말 삭제하시겠습니까?"
                data-test={`project-list-item-${index}`}
                onConfirm={() => deleteFA(record.id)}
              >
                <Button size="small">삭제</Button>
              </Popconfirm>
            </div>
          </Space>
        ),
    },
  ];

  return (
    <StyledDiv>
      {data && (
        <Table<any>
          rowKey="id"
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}

export default FAListComponent;
